'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';

var AI_BUY_COMPETITIVE_ANALYSIS = '/api-gateway/v1.0/buy-package/competitive-analysis-report';
var buyCompetitiveAnalysis = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var jobId, resumeId, productId, quantity, accessToken, msBaseUrl, langCode, api, res, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                jobId = params.jobId, resumeId = params.resumeId, productId = params.productId, quantity = params.quantity, accessToken = params.accessToken, msBaseUrl = params.msBaseUrl, langCode = params.langCode;
                api = "".concat(msBaseUrl).concat(AI_BUY_COMPETITIVE_ANALYSIS);
                return [4 /*yield*/, fetch(api, {
                        method: 'POST',
                        headers: {
                            'Accept-Language': langCode,
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(accessToken)
                        },
                        body: JSON.stringify({
                            jobId: jobId,
                            resumeId: resumeId,
                            product: [
                                {
                                    productId: productId,
                                    quantity: quantity
                                }
                            ]
                        })
                    })];
            case 1:
                res = _a.sent();
                if (!(res.status === 200)) return [3 /*break*/, 3];
                return [4 /*yield*/, res.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3: return [2 /*return*/, null];
            case 4:
                e_1 = _a.sent();
                console.error('error', e_1);
                return [2 /*return*/, null];
            case 5: return [2 /*return*/];
        }
    });
}); };

export { AI_BUY_COMPETITIVE_ANALYSIS, buyCompetitiveAnalysis };
//# sourceMappingURL=services.js.map
